<div class="editor">
    <!-- Hiển thị tiêu đề mở rộng -->
    <div class="editor-header" *ngIf="isViewAll">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
    </div>
    <ng-container *ngIf="!isViewAll">
      <app-position-out-config [elementChoosing]="objectChoosing" [device]="device" [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>
  
      <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing" [width]="class['text-expire']['width']" [height]="class['text-expire']['height']"
          (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
      <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
     
        
        <!-- CHỮ VÀ ĐỊNH DẠNG -->
        <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
          <div class="editor-field">
            <div class="editor-field-body">
              <!-- Lựa chọn hiển thị cho các thiết bị -->
              <app-hide-show-config
                  [device]="device"
                  [elementChoosing]="objectChoosing">
              </app-hide-show-config>
              <!-- Định dạng thời gian -->
              <div class="field-row">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <p class="m-0" style="line-height:1.5">Hiển thị theo dạng thời gian còn lại</p>
                  <nz-switch
                    [(ngModel)]="config['date']['date_type_check']"
                    (ngModelChange)="handleSetDateFormatStyle()">
                  </nz-switch>
                </div>
                <div class="container-gradient" *ngIf="!config['date']['date_type_check']">
                    <nz-radio-group [(ngModel)]="config['date']['date_format_style']" (ngModelChange)="updateObject()">
                      <label nz-radio nzValue="dd-MM-yyyy">DD-MM-YYYY</label>
                      <label nz-radio nzValue="dd/MM/yyyy">DD/MM/YYYY</label>
                      <!-- <label nz-radio nzValue="3">DD, MM, YYYY</label> -->
                      <!-- <label nz-radio nzValue="4">DD/MM/YYYY, TIME</label>
                      <label nz-radio nzValue="5">MM , YYYY , TIME</label> -->
                    </nz-radio-group>
                </div>
                <div class="container-gradient" *ngIf="config['date']['date_type_check']">
                  <nz-radio-group [(ngModel)]="config['date']['date_format_style']" (ngModelChange)="updateObject()">
                    <label nz-radio nzValue="1">Hiển thị năm</label>
                    <label nz-radio nzValue="2">Hiển thị tháng</label>
                    <label nz-radio nzValue="3">Hiển thị ngày</label>
                    <label nz-radio nzValue="4">Hiển thị ngày tháng</label>
                    <label nz-radio nzValue="5">Hiển thị ngày tháng năm</label>
                  </nz-radio-group>
                </div>
              </div>

              <app-text-format-config
                    [device]="device"
                    [objectChoosing]="objectChoosing"
                    [class]="class"
                    [config]="config"
                    
                    [staticdata]="staticdata"
                    [textContentClass]="class['text-expire__content']"
                    [textWrapperClass]="class['text-expire__wrapper']"
                    >
              </app-text-format-config>
              <div class="field-row">
                <div class="config-font" style="margin-top:20px">
                  <!-- Khoảng cách chữ -->
                  <div class="font-text-letterspacing">
                    <div class="config-name" style="gap:5px">
                      <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_chu' | translate }}</p>
                      <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                        [ngModel]="class['text-expire__content']['letter-spacing'] | vhnumber"
                        (nzBlur)="updateClass()"
                        (ngModelChange)="class['text-expire__content']['letter-spacing'] = $event +'px'">
                      </nz-input-number>
                    </div>
                    <nz-row>
                      <nz-col nzSpan="24">
                        <nz-slider [nzMin]="0" [nzMax]="50"
                          [ngModel]="class['text-expire__content']['letter-spacing'] | vhnumber"
                          (nzOnAfterChange)="updateClass();"
                          (ngModelChange)="class['text-expire__content']['letter-spacing'] = $event +'px'">
                        </nz-slider>
                      </nz-col>
                    </nz-row>
                  </div>
                  <!-- Khoảng cách dòng -->
                  <div class="font-text-linespacing">
                    <div class="config-name">
                      <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_dong' | translate }}</p>
                      <nz-input-number [ngStyle]="{ width: '40%' }"
                        [(ngModel)]="this.class['text-expire__content']['line-height']"
                        (nzBlur)="updateClass()"
                        [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1">
                      </nz-input-number>
                    </div>
                    <nz-row>
                      <nz-col nzSpan="24">
                        <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                          [(ngModel)]="this.class['text-expire__content']['line-height']"
                          (nzOnAfterChange)="updateClass()">
                        </nz-slider>
                      </nz-col>
                    </nz-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <!-- PHONG CÁCH -->
        <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
          <app-text-style-config
                [config]="config"
                [class]="class"
                [staticdata]="staticdata"
                [device]="device"
                [objectChoosing]="objectChoosing"
                [textContentClass]="class['text-expire__content']"
                [textWrapperClass]="class['text-expire']"
                [filterConfig]="config['text-shadow']"
                [isShape]="false"
          >
          </app-text-style-config>
        </li>
        <!-- HIỆU ỨNG -->
        <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
          <div class="editor-field">
            <div class="editor-field-body">
              <div class="field-row" style="margin-bottom: 0px;">
                <div class="text-effect">
                  <!-- Chọn kiểu -->
                  <nz-select [(ngModel)]="staticdata[device + '_animation_type']" (ngModelChange)="changeTypeAnimation()">
                    <nz-option *ngIf="device == 'desktop'" nzValue="hover" nzLabel="Khi rê chuột"></nz-option>
                    <nz-option nzValue="keyframes" nzLabel="Tự động"></nz-option>
                    <nz-option nzValue="visible" nzLabel="Khi xuất hiện"></nz-option>
                  </nz-select>
                  <!-- Chọn hiệu ứng -->
                  <div class="button-hover" nz-row>
                    <div nz-col nzSpan="10" class="effect-button" style="overflow:hidden;" *ngFor="let e of effect_hover_data?.data"
                        (click)="chooseHover(e)"
                        [ngClass]="{'selected': e.id === config['animation-selected'].id ? true : false}">
                        <button [ngClass]="'animation-0'" (mouseover)="vhQueryAutoWeb.animationFromJSON($event, e)">
                            <span style="font-size: 13px; white-space: normal; z-index: 1000">{{e.name}}</span>
                        </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </ng-container>
  
    <!-- CẤU HÌNH CHI TIẾT -->
    <div class="view-more" *ngIf="isViewAll">
        <!-- Cấu hình chi tiết HIỆU ỨNG -->
        <div class="editor_effect-hover" *ngIf="config['animation-selected'].id != '000000'">
             <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize">
            </app-animations-config>
        </div>
    </div>
  </div>